import React from 'react';
import { colors } from '../../lib/colors';

interface LogoutConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity backdrop-blur-sm animate-fadeIn"
        onClick={onCancel}
      />
      
      {/* Modal Container - Mobile optimized */}
      <div className="flex min-h-full items-end sm:items-center justify-center p-0 sm:p-4">
        <div 
          className="relative transform overflow-hidden rounded-t-xl sm:rounded-xl bg-white shadow-xl transition-all w-full sm:max-w-md"
          onClick={(e) => e.stopPropagation()}
        >
        {/* Modal Header with PCM Branding */}
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div 
              className="w-12 h-12 rounded-lg flex items-center justify-center"
              style={{
                background: `linear-gradient(135deg, ${colors.brand.primary} 0%, ${colors.brand.accent} 100%)`,
                boxShadow: `0 4px 12px -2px ${colors.brand.primary}40`
              }}
            >
              <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">PCM Portal</h2>
              <p className="text-sm text-gray-500">Logout Confirmation</p>
            </div>
          </div>
        </div>

        {/* Modal Body */}
        <div className="p-6">
          <p className="text-gray-700 text-center mb-6">
            Are you sure you want to log out of PCM Portal?
          </p>
          
          {/* Action Buttons */}
          <div className="flex flex-col-reverse sm:flex-row gap-3 pb-safe">
            <button
              onClick={onCancel}
              className="w-full sm:flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="w-full sm:flex-1 px-4 py-2.5 text-white rounded-lg font-medium transition-all hover:opacity-90"
              style={{
                background: `linear-gradient(135deg, ${colors.brand.primary} 0%, ${colors.brand.accent} 100%)`,
                boxShadow: `0 4px 12px -2px ${colors.brand.primary}40`
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};